import { Controller } from '@hotwired/stimulus'

// One-click role packs for sub-admin feature permissions.
export default class extends Controller {
  static targets = ['checkbox', 'templateButton', 'status', 'clearButton']
  static values = {
    templates: Array,
    disabled: Boolean
  }

  connect () {
    this.syncFromCheckboxes()
  }

  apply (event) {
    if (this.disabledValue) return

    const key = event.currentTarget.dataset.templateKey
    const template = this.templatesValue.find((item) => item.key === key)
    if (!template) return

    const allowed = new Set(template.permissions)
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = allowed.has(checkbox.value)
    })
    this.setActiveTemplate(key)
    this.setStatus(`${template.label} applied · ${template.permissions.length} permissions`)
  }

  clear () {
    if (this.disabledValue) return

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
    this.setActiveTemplate(null)
    this.setStatus('Cleared · pick a role pack or customize below')
  }

  syncFromCheckboxes () {
    if (this.disabledValue) {
      this.setStatus('Super admin has full access')
      this.setActiveTemplate(null)
      return
    }

    const selected = this.selectedPermissions()
    if (selected.length === 0) {
      this.setActiveTemplate(null)
      this.setStatus('No permissions selected')
      return
    }

    const match = this.templatesValue.find((template) => {
      const pack = [...template.permissions].sort().join(',')
      return pack === selected.join(',')
    })

    if (match) {
      this.setActiveTemplate(match.key)
      this.setStatus(`${match.label} · ${selected.length} permissions`)
    } else {
      this.setActiveTemplate(null)
      this.setStatus(`Custom mix · ${selected.length} permissions`)
    }
  }

  selectedPermissions () {
    return this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value)
      .sort()
  }

  setActiveTemplate (key) {
    this.templateButtonTargets.forEach((button) => {
      const active = button.dataset.templateKey === key
      button.classList.toggle('ring-2', active)
      button.classList.toggle('ring-admin-500', active)
      button.classList.toggle('border-admin-500', active)
      button.classList.toggle('bg-admin-50', active)
      button.setAttribute('aria-pressed', active ? 'true' : 'false')
    })
  }

  setStatus (text) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = text
  }
}
